import { ChangeDetectorRef, Component, Input, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { DeleteReasonComponent } from 'src/app/Others/delete-reason/delete-reason.component';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';

interface CheckIn {
  companyId: number,
  date: Date,
  id: number,
  remark: string,
  username: string,
  dateCreated: Date
}

interface DeletedCheckInRecord {
  companyId: number,
  date: Date,
  id: number,
  dateCreated: Date,
  deleteBy: string,
  deleteReason: string,
  checkInCreatedBy: string
}

interface DeletedCheckIn {
  deletedOn: Date,
  deletedList: DeletedCheckInRecord[]
}

@Component({
    selector: 'app-check-in-history',
    templateUrl: './check-in-history.component.html',
    styleUrls: ['./check-in-history.component.scss'],
    standalone: false
})
export class CheckInHistoryComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private restApi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  private router = inject(Router);
  protected sharedService = inject(SharedService);
  protected enums = inject(Enums);
  private cdr = inject(ChangeDetectorRef);

  @Input() selectedCompanyId: number;
  @Input() selectedCompanyCode: number;
  @Input() selectedRole: number;

  isCollapsed = true;
  isDirty = false;

  checkInList: CheckIn[] = [];

  deletedCheckInList: DeletedCheckIn[] = [];

  ngOnInit(): void {
    this.getCheckInHistory();
    this.getDeletedCheckInHistory();
  }

  getCheckInHistory() {
    const xhttp = this.restApi.getRequest(this.constructApi.getCompanyCheckInHistory(this.selectedCompanyId, this.selectedRole))
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        // Typical action to be performed when the document is ready:

        const jsonArray = JSON.parse((xhttp.responseText));
        jsonArray.forEach(json => {
          const checkIn = { companyId: json.companyId, date: json.date, id: json.id, remark: json.remark, username: json.username, dateCreated: json.dateCreated };

          this.checkInList.push(checkIn);
        });
      }
    };
  }

  getDeletedCheckInHistory() {
    const xhttp = this.restApi.getRequest(this.constructApi.getCompanyDeletedCheckInHistory(this.selectedCompanyId))
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        // Typical action to be performed when the document is ready:

        const jsonArray = JSON.parse((xhttp.responseText));
        jsonArray.forEach(json => {
          const deletedOn = new Date(json.delete_on);
          const formattedDeleteOn = new Date(deletedOn.getFullYear(), deletedOn.getMonth(), deletedOn.getDate(), 0, 0, 0);
          const deletedRecord = { companyId: json.companyId, date: json.date, id: json.id, dateCreated: json.dateCreated, deleteBy: json.delete_by, deleteReason: json.delete_reason, checkInCreatedBy: json.username };

          const index = this.deletedCheckInList.findIndex(deleted => deleted.deletedOn.getFullYear() == formattedDeleteOn.getFullYear() && deleted.deletedOn.getMonth() == formattedDeleteOn.getMonth() && deleted.deletedOn.getDate() == formattedDeleteOn.getDate());

          if (index == -1) {
            const deletedCheckIn = { deletedOn: formattedDeleteOn, deletedList: [deletedRecord] }
            this.deletedCheckInList.push(deletedCheckIn);
          }
          else {
            this.deletedCheckInList[index].deletedList.push(deletedRecord)
          }
        });
      }
    };
  }

  goToListHutang(date: Date) {
    const dateStr = new Date(date).toISOString();
    this.router.navigate(['/listHutang', this.selectedCompanyId, dateStr]);
    this.closeModal();
  }

  closeModal() {
    if (this.isDirty == true)
      window.location.reload();
    this.activeModal.close();
  }

  confirmDeleteSinceDateCheckIn(companyId: number, checkInDate: Date) {
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "Confirm to delete checkin since date " + checkInDate + "?";

    modalRef.result.then((confirm) => {
      if (confirm) {
        const modalRef = this.sharedService.openModal(DeleteReasonComponent);
        modalRef.componentInstance.passEntry.subscribe((entry) => {
          const remark = entry;

          //append added account to account list
          this.deleteCheckInSinceDate(remark, companyId, checkInDate);
        });
      }
    });
  }

  confirmBeforeDeleteCheckIn(companyId: number, checkInId: number, indexInList: number) {
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "Confirm to delete checkin ?";

    modalRef.result.then((confirm) => {
      if (confirm) {
        const modalRef = this.sharedService.openModal(DeleteReasonComponent);
        modalRef.componentInstance.passEntry.subscribe((entry) => {
          const remark = entry;

          //append added account to account list
          this.deleteCheckIn(remark, companyId, checkInId, indexInList);
        });
      }
    });
  }

  deleteCheckIn(remark: string, companyId: number, checkInId: number, indexInList: number) {
    const data =
    {
      "reason": remark
    };

    const xhr = this.restApi.deleteRequest(this.constructApi.getDeleteCheckIn(companyId, checkInId), data);

    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        if (xhr.readyState == 4 && xhr.status == 200) {
          if (xhr.status == 200) {
            this.isDirty = true;
            this.checkInList.splice(Number(indexInList), 1);
            this.cdr.detectChanges();
          }
          else {
            this.sharedService.openAlert("Opps, some errors occured. Please try again later", ALERT_TYPE.DANGER);
          }
        }
      }
    }
  }

  deleteCheckInSinceDate(remark: string, companyId: number, checkInDate: Date) {
    const data =
    {
      "reason": remark
    };

    const xhr = this.restApi.deleteRequest(this.constructApi.getDeleteCheckInSinceDate(companyId, checkInDate), data);

    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        if (xhr.readyState == 4 && xhr.status == 200) {
          if (xhr.status == 200) {
            window.location.reload();
          }
          else {
            this.sharedService.openAlert("Opps, some errors occured. Please try again later", ALERT_TYPE.DANGER);
          }
        }
      }
    }
  }
}
